import React from 'react';
import { Card, CardHeader, CardBody } from './../../components/card/card.jsx';
import 'lity';
import 'lity/dist/lity.min.css';
import { Icon } from '@iconify/react';

function Profile() {
	return (
		<div className="profile">
			<div className="profile-sidebar">
				<div className="desktop-sticky-top small">
					<img src="/quantum-react/assets/img/user/profile.jpg" className="object-fit-cover h-200px w-100 d-block mb-4" alt="" />
					
					<h4 className="mb-0">John Smith</h4>
					<div className="mb-3 text-theme">@johnsmith</div>
					<p>
						Principal UXUI Design & Brand Architecture for Studio. Creator of SeanTheme.
						Bringing the world closer together. Studied Computer Science and Psychology at Harvard University.
					</p>
					<div className="mb-1">
						<i className="fa fa-map-marker-alt fa-fw opacity-5 me-1"></i> New York, NY
					</div>
					<div className="mb-3">
						<i className="fa fa-link fa-fw opacity-5 me-1"></i> seantheme.com/studio-svelte
					</div>
					
					<hr className="my-4" />
					
					<div className="fw-semibold mb-3 fs-12px">People to follow</div>
					<div className="d-flex align-items-center mb-3">
						<img src="/quantum-react/assets/img/user/user-1.jpg" alt="" width="30" />
						<div className="flex-fill px-3">
							<div className="fw-semibold text-white text-truncate w-100px">Noor Rowe</div>
							<div className="small text-white text-opacity-50">3.1m followers</div>
						</div>
						<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
					</div>
					<div className="d-flex align-items-center mb-3">
						<img src="/quantum-react/assets/img/user/user-2.jpg" alt="" width="30" />
						<div className="flex-fill px-3">
							<div className="fw-semibold text-white text-truncate w-100px">Abbey Parker</div>
							<div className="small text-white text-opacity-50">302k followers</div>
						</div>
						<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
					</div>
					<div className="d-flex align-items-center mb-3">
						<img src="/quantum-react/assets/img/user/user-3.jpg" alt="" width="30" />
						<div className="flex-fill px-3">
							<div className="fw-semibold text-white text-truncate w-100px">Savannah Nicholson</div>
							<div className="small text-white text-opacity-50">720k followers</div>
						</div>
						<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
					</div>
					<div className="d-flex align-items-center mb-3">
						<img src="/quantum-react/assets/img/user/user-4.jpg" alt="" width="30" />
						<div className="flex-fill px-3">
							<div className="fw-semibold text-white text-truncate w-100px">Kenny Bright</div>
							<div className="small text-white text-opacity-50">1.4m followers</div>
						</div>
						<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
					</div>
					<div className="d-flex align-items-center">
						<img src="/quantum-react/assets/img/user/user-5.jpg" alt="" width="30" />
						<div className="flex-fill px-3">
							<div className="fw-semibold text-white text-truncate w-100px">Cara Poole</div>
							<div className="small text-white text-opacity-50">989k followers</div>
						</div>
						<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
					</div>
				</div>
			</div>
			
			<div className="profile-content">
				<div className="row">
					<div className="col-xl-8">
						<ul className="profile-tab nav nav-tabs nav-tabs-v2 mb-3">
							<li className="nav-item">
								<a href="#profile-post" className="nav-link active" data-bs-toggle="tab">
									<div className="nav-field">Posts</div>
									<div className="nav-value">382</div>
								</a>
							</li>
							<li className="nav-item">
								<a href="#profile-followers" className="nav-link" data-bs-toggle="tab">
									<div className="nav-field">Followers</div>
									<div className="nav-value">1.3m</div>
								</a>
							</li>
							<li className="nav-item">
								<a href="#profile-media" className="nav-link" data-bs-toggle="tab">
									<div className="nav-field">Photos</div>
									<div className="nav-value">1,397</div>
								</a>
							</li>
							<li className="nav-item">
								<a href="#profile-video" className="nav-link" data-bs-toggle="tab">
									<div className="nav-field">Videos</div>
									<div className="nav-value">120</div>
								</a>
							</li>
							<li className="nav-item">
								<a href="#profile-followers" className="nav-link" data-bs-toggle="tab">
									<div className="nav-field">Following</div>
									<div className="nav-value">2,592</div>
								</a>
							</li>
						</ul>
						<div className="tab-content p-0">
							<div className="tab-pane fade show active" id="profile-post">
								<Card className="mb-3">
									<CardBody>
										<div className="d-flex align-items-center">
											<a href="#/"><img src="/quantum-react/assets/img/user/profile.jpg" alt="" width="36" /></a>
											<div className="flex-fill ps-3">
												<div className="fw-semibold"><a href="#/" className="text-decoration-none">Clyde Stanley</a> at <a href="#/" className="text-decoration-none">South Lake Tahoe, California</a></div>
												<div className="text-body text-opacity-50 small">March 16</div>
											</div>
										</div>
										
										<div className="my-3">Best vacation of 2026</div>
										<div className="profile-img-list mb-1">
											<div className="profile-img-list-item main"><a href="/quantum-react/assets/img/gallery/gallery-80.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-80.jpg)' }}></span></a></div>
											<div className="profile-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-81.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-81.jpg)' }}></span></a></div>
											<div className="profile-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-82.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-82.jpg)' }}></span></a></div>
											<div className="profile-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-83.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-83.jpg)' }}></span></a></div>
											<div className="profile-img-list-item with-number">
												<a href="/quantum-react/assets/img/gallery/gallery-84.jpg" data-lity data-sveltekit-reload className="profile-img-list-link">
													<span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-84.jpg)' }}></span>
													<div className="profile-img-number">+12</div>
												</a>
											</div>
										</div>
										
										<div className="row mb-n3 pb-1">
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:thumb-up-outline" className="fs-16px me-2 my-n1" /> Likes
												</a>
											</div>
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:chat-bubble-outline" className="fs-16px me-2 my-n1" /> Comment
												</a>
											</div>
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:arrow-top-right" className="fs-16px me-2 my-n1" /> Share
												</a>
											</div>
										</div>
									</CardBody>
									<CardBody>
										<div className="d-flex align-items-center">
											<img src="/quantum-react/assets/img/user/user.jpg" alt="" width="30" />
											<div className="flex-fill ps-2">
												<div className="position-relative d-flex align-items-center">
													<input type="text" className="form-control" placeholder="Write a comment..." />
													<div className="position-absolute end-0 text-center">
														<a href="#/" className="text-muted me-2"><i className="fa fa-smile"></i></a>
														<a href="#/" className="text-muted me-2"><i className="fa fa-camera"></i></a>
														<a href="#/" className="text-muted me-2"><i className="fa fa-video"></i></a>
														<a href="#/" className="text-muted me-3"><i className="fa fa-paw"></i></a>
													</div>
												</div>
											</div>
										</div>
									</CardBody>
								</Card>
								<Card className="mb-3">
									<CardBody>
										<div className="d-flex align-items-center mb-3">
											<a href="#/"><img src="/quantum-react/assets/img/user/profile.jpg" alt="" width="36" /></a>
											<div className="flex-fill ps-3">
												<div className="fw-semibold"><a href="#/" className="text-decoration-none">Clyde Stanley</a> is watching <a href="#/" className="text-decoration-none">PATAGONIA 8k</a></div>
												<div className="text-body text-opacity-50 small">March 12</div>
											</div>
										</div>
					
										<div className="mb-3">Nice PATAGONIA footage in 8K</div>
										<div className="ratio ratio-16x9 mb-1">
											<iframe src="https://www.youtube.com/embed/ChOhcHD8fBA?showinfo=0" title="Youtube"></iframe>
										</div>
										
										<div className="row mb-n3 pb-1">
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:thumb-up-outline" className="fs-16px me-2 my-n1" /> Likes
												</a>
											</div>
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:chat-bubble-outline" className="fs-16px me-2 my-n1" /> Comment
												</a>
											</div>
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:arrow-top-right" className="fs-16px me-2 my-n1" /> Share
												</a>
											</div>
										</div>
									</CardBody>
									<CardBody>
										<div className="d-flex align-items-center">
											<img src="/quantum-react/assets/img/user/user.jpg" alt="" width="30" />
											<div className="flex-fill ps-2">
												<div className="position-relative d-flex align-items-center">
													<input type="text" className="form-control" placeholder="Write a comment..." />
													<div className="position-absolute end-0 text-center">
														<a href="#/" className="text-muted me-2"><i className="fa fa-smile"></i></a>
														<a href="#/" className="text-muted me-2"><i className="fa fa-camera"></i></a>
														<a href="#/" className="text-muted me-2"><i className="fa fa-video"></i></a>
														<a href="#/" className="text-muted me-3"><i className="fa fa-paw"></i></a>
													</div>
												</div>
											</div>
										</div>
									</CardBody>
								</Card>
								<Card className="mb-3">
									<CardBody>
										<div className="d-flex align-items-center mb-3">
											<a href="#/" className="text-decoration-none"><img src="/quantum-react/assets/img/user/profile.jpg" alt="" width="36" /></a>
											<div className="flex-fill ps-3">
												<div className="fw-semibold"><a href="#/" className="text-decoration-none">Clyde Stanley</a></div>
												<div className="text-body text-opacity-50 small">March 4</div>
											</div>
										</div>
					
										<div className="mb-1">
											Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />Quisque sodales urna justo, ac ultrices magna consectetur id.<br /><br />
											Donec tempor ligula sit amet nunc porta, sed aliquam leo sagittis.<br />
											Ut auctor congue efficitur. Praesent aliquam pulvinar neque, placerat semper massa elementum et.
										</div>
										
										<div className="row mb-n3 pb-1">
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:thumb-up-outline" className="fs-16px me-2 my-n1" /> Likes
												</a>
											</div>
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:chat-bubble-outline" className="fs-16px me-2 my-n1" /> Comment
												</a>
											</div>
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:arrow-top-right" className="fs-16px me-2 my-n1" /> Share
												</a>
											</div>
										</div>
									</CardBody>
									<CardBody>
										<div className="d-flex align-items-center">
											<img src="/quantum-react/assets/img/user/user.jpg" alt="" width="30" />
											<div className="flex-fill ps-2">
												<div className="position-relative d-flex align-items-center">
													<input type="text" className="form-control" placeholder="Write a comment..." />
													<div className="position-absolute end-0 text-center">
														<a href="#/" className="text-muted me-2"><i className="fa fa-smile"></i></a>
														<a href="#/" className="text-muted me-2"><i className="fa fa-camera"></i></a>
														<a href="#/" className="text-muted me-2"><i className="fa fa-video"></i></a>
														<a href="#/" className="text-muted me-3"><i className="fa fa-paw"></i></a>
													</div>
												</div>
											</div>
										</div>
									</CardBody>
								</Card>
								<Card className="mb-3">
									<CardBody>
										<div className="d-flex align-items-center mb-3">
											<a href="#/"><img src="/quantum-react/assets/img/user/profile.jpg" alt="" width="36" /></a>
											<div className="flex-fill ps-3">
												<div className="fw-semibold"><a href="#/" className="text-decoration-none">Clyde Stanley</a> at <a href="#/" className="text-decoration-none">United States</a></div>
												<div className="text-body text-opacity-50 small">May 5</div>
											</div>
										</div>
						
										<div className="mb-3">Business Trip</div>
										<div className="profile-img-list mb-1">
											<div className="profile-img-list-item main"><a href="/quantum-react/assets/img/gallery/gallery-5.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-91.jpg)' }}></span></a></div>
											<div className="profile-img-list-item main"><a href="/quantum-react/assets/img/gallery/gallery-6.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-92.jpg)' }}></span></a></div>
											<div className="profile-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-7.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-93.jpg)' }}></span></a></div>
											<div className="profile-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-8.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-94.jpg)' }}></span></a></div>
											<div className="profile-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-9.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-95.jpg)' }}></span></a></div>
											<div className="profile-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-10.jpg" data-lity data-sveltekit-reload className="profile-img-list-link"><span className="profile-img-content" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-96.jpg)' }}></span></a></div>
										</div>
										
										<div className="row mb-n3 pb-1">
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:thumb-up-outline" className="fs-16px me-2 my-n1" /> Likes
												</a>
											</div>
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:chat-bubble-outline" className="fs-16px me-2 my-n1" /> Comment
												</a>
											</div>
											<div className="col">
												<a href="#/" className="text-body text-opacity-75 text-decoration-none d-flex align-items-center justify-content-center p-2">
													<Icon icon="material-symbols-light:arrow-top-right" className="fs-16px me-2 my-n1" /> Share
												</a>
											</div>
										</div>
									</CardBody>
									<CardBody>
										<div className="d-flex align-items-center">
											<img src="/quantum-react/assets/img/user/user.jpg" alt="" width="30" />
											<div className="flex-fill ps-2">
												<div className="position-relative d-flex align-items-center">
													<input type="text" className="form-control" placeholder="Write a comment..." />
													<div className="position-absolute end-0 text-center">
														<a href="#/" className="text-muted me-2"><i className="fa fa-smile"></i></a>
														<a href="#/" className="text-muted me-2"><i className="fa fa-camera"></i></a>
														<a href="#/" className="text-muted me-2"><i className="fa fa-video"></i></a>
														<a href="#/" className="text-muted me-3"><i className="fa fa-paw"></i></a>
													</div>
												</div>
											</div>
										</div>
									</CardBody>
								</Card>
							</div>
							
							<div className="tab-pane fade" id="profile-followers">
								<Card>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Ethel Wilkes</a></div>
											<div className="text-white text-opacity-50 small">North Raundspic</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-2.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Shanaya Hansen</a></div>
											<div className="text-white text-opacity-50 small">North Raundspic</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-3.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">James Allman</a></div>
											<div className="text-white text-opacity-50 small">North Raundspic</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-4.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Marie Welsh</a></div>
											<div className="text-white text-opacity-50 small">Crencheporford</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-5.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Lamar Kirkland</a></div>
											<div className="text-white text-opacity-50 small">Prince Ewoodswan</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-6.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Bentley Osborne</a></div>
											<div className="text-white text-opacity-50 small">Red Suvern</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-7.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Ollie Goulding</a></div>
											<div className="text-white text-opacity-50 small">Doa</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-8.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Hiba Calvert</a></div>
											<div className="text-white text-opacity-50 small">Stemunds</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-9.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Rivka Redfern</a></div>
											<div className="text-white text-opacity-50 small">Fallnee</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
									<CardBody className="d-flex align-items-center">
										<img src="/quantum-react/assets/img/user/user-10.jpg" alt="" width="36" />
										<div className="flex-fill px-3">
											<div><a href="#/" className="text-white fw-semibold text-decoration-none">Roshni Fernandez</a></div>
											<div className="text-white text-opacity-50 small">Mount Lerdo</div>
										</div>
										<a href="#/" className="btn btn-sm btn-outline-theme">Follow</a>
									</CardBody>
								</Card>
								<div className="text-center p-3"><a href="#/" className="text-body text-decoration-none">Show more <b className="caret"></b></a></div>
							</div>
							
							<div className="tab-pane fade" id="profile-media">
								<Card>
									<CardHeader>MAY 20</CardHeader>
									<CardBody className="p-0">
										<div className="widget-img-list">
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-1.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-1.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-2.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-2.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-3.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-3.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-4.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-4.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-5.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-5.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-6.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-6.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-7.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-7.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-8.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-8.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-9.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-9.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-10.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-10.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-11.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-11.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-12.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-12.jpg)' }}></span></a></div>
										</div>
									</CardBody>
									<CardHeader>MAY 16</CardHeader>
									<CardBody className="p-0">
										<div className="widget-img-list">
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-13.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-13.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-14.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-14.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-15.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-15.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-16.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-16.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-17.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-17.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-18.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-18.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-19.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-19.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-20.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-20.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-21.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-21.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-22.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-22.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-23.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-23.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-24.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-24.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-25.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-25.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-26.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-26.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-27.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-27.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-28.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-28.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-29.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-29.jpg)' }}></span></a></div>
											<div className="widget-img-list-item"><a href="/quantum-react/assets/img/gallery/gallery-30.jpg" data-lity data-sveltekit-reload><span className="img" style={{ backgroundImage: 'url(/quantum-react/assets/img/gallery/gallery-30.jpg)' }}></span></a></div>
										</div>
									</CardBody>
								</Card>
								<div className="text-center p-3"><a href="#/" className="text-body text-decoration-none">Show more <b className="caret"></b></a></div>
							</div>
							
							<div className="tab-pane fade" id="profile-video">
								<Card className="mb-3">
									<CardHeader>COLLECTIONS #1</CardHeader>
									<CardBody className="p-0">
										<div className="row gx-1">
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=N9SlWUo1iBA" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/N9SlWUo1iBA/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=0AcncLM3yRY" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/0AcncLM3yRY/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=JUh4koZ8Uqw" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/JUh4koZ8Uqw/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=juvg1Bai7OA" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/juvg1Bai7OA/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=RRmwjIgBAfI" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/RRmwjIgBAfI/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=6wewEiRYczw" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/6wewEiRYczw/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=4NW1cl-gyIU" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/4NW1cl-gyIU/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=KCONWLnm7FQ" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/KCONWLnm7FQ/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
										</div>
									</CardBody>
									<CardHeader>COLLECTIONS #2</CardHeader>
									<CardBody className="p-0">
										<div className="row gx-1">
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=HTJt2gfG6f4" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/HTJt2gfG6f4/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=-SxrHSzCQnc" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/-SxrHSzCQnc/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=ZtT3jaTcCsY" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/ZtT3jaTcCsY/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=ml1I1mYZHjQ" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/ml1I1mYZHjQ/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=lEA7RuDt7YA" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/lEA7RuDt7YA/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=AQ79_eDLg4w" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/AQ79_eDLg4w/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=W0PrnBQs_W4" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/W0PrnBQs_W4/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
											<div className="col-md-4 col-6 mb-1">
												<a href="https://www.youtube.com/watch?v=NcBjx_eyvxc" data-lity data-sveltekit-reload="">
													<img src="https://img.youtube.com/vi/NcBjx_eyvxc/mqdefault.jpg" alt="" className="d-block w-100" />
												</a>
											</div>
										</div>
									</CardBody>
								</Card>
							</div>
						</div>
					</div>
					<div className="col-xl-4">
						<div className="desktop-sticky-top d-none d-lg-block">
							<div className="fw-500 px-0 d-flex text-white my-3">
								<span className="flex-fill">Trends for you</span> 
								<a href="#/" className="text-white"><i className="fa fa-cog"></i></a>
							</div>
							<Card className="mb-3">
								<CardBody className="px-3 py-2">
									<div className="text-white fw-semibold small">Trending Worldwide</div>
									<div className="text-theme fw-semibold mb-2">#BreakingNews</div>
									<a href="#/" className="Card overflow-hidden mb-1 text-body text-decoration-none">
										<div className="row gx-0">
											<div className="col-md-8">
												<div className="CardBody p-2 px-3">
													<div className="fs-10px text-white text-opacity-50 mb-1">Space</div>
													<div className="h-30px fs-12px overflow-hidden lh-sm mb-1">Distant star explosion is brightest ever seen, study finds</div>
												</div>
											</div>
											<div className="col-md-4 d-flex">
												<div className="h-100 w-100" style={{ background: 'url(/quantum-react/assets/img/gallery/news-1.jpg) center', backgroundSize: 'cover' }}></div>
											</div>
										</div>
									</a>
									<div><small className="text-white text-opacity-50">1.89m share</small></div>
								</CardBody>
								<CardBody className="px-3 py-2">
									<div className="text-theme fw-semibold mb-2">#TrollingForGood</div>
									<div className="fs-11px lh-sm">Be a good Troll and spread some positivity on Studio today.</div>
									<div><small className="text-white text-opacity-50"><i className="fa fa-external-link-square-alt"></i> Promoted by Studio Trolls</small></div>
								</CardBody>
								<CardBody className="px-3 py-2">
									<div className="text-white fw-semibold small">Trending Worldwide</div>
									<div className="text-theme fw-semibold mb-2">#CronaOutbreak</div>
									<div className="fs-13px">The coronavirus is affecting 210 countries around the world and 2 ...</div>
									<div><small className="text-white text-opacity-50">49.3m share</small></div>
								</CardBody>
								<CardBody className="px-3 py-2">
									<div className="text-white fw-semibold small">Trending in New York</div>
									<div className="text-theme fw-semibold mb-2">#CoronavirusPandemic</div>
									<a href="#/" className="Card overflow-hidden mb-1 text-body text-decoration-none">
										<div className="row gx-0">
											<div className="col-md-8">
												<div className="CardBody py-2 px-3">
													<div className="fs-10px text-white text-opacity-50 mb-1">Coronavirus</div>
													<div className="h-30px fs-12px overflow-hidden lh-sm mb-1">Coronavirus: US suspends travel from Europe</div>
												</div>
											</div>
											<div className="col-md-4 d-flex">
												<div className="h-100 w-100" style={{ background: 'url(/quantum-react/assets/img/gallery/news-2.jpg) center', backgroundSize: 'cover' }}></div>
											</div>
										</div>
									</a>
									<div><small className="text-white text-opacity-50">821k share</small></div>
								</CardBody>
								<CardBody className="px-3 py-2">
									<div className="text-white fw-semibold small">Trending Worldwide</div>
									<div className="text-theme fw-semibold mb-2">#ClimateChangeAction</div>
									<div className="fs-13px">Global movements and initiatives are increasing to address climate change...</div>
									<div><small className="text-white text-opacity-50">35.2m shares</small></div>
								</CardBody>
								<CardBody className="p-0">
									<a href="#/" className="list-group-item list-group-action text-center px-3 py-2">
										Show more
									</a>
								</CardBody>
							</Card>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Profile;